var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("h4", { staticClass: "modal-title" }, [_vm._v("Add credit")]),
        _vm._v(" "),
        _c("button", {
          staticClass: "btn-close",
          attrs: { type: "button", "aria-label": "Close" },
          on: {
            click: function ($event) {
              return _vm.$emit("hide-modal")
            },
          },
        }),
      ]),
      _vm._v(" "),
      _setup.formId
        ? _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c(_setup.Form, { attrs: { "form-id": _setup.formId } }),
              _vm._v(" "),
              _c(
                "footer",
                { staticClass: "text-center mt-3" },
                [
                  _c(_setup.FormSaveBtn, {
                    attrs: {
                      "button-text": "Save",
                      "cancel-on-save": true,
                      "form-id": _setup.formId,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }